module.exports = __webpack_public_path__ + "static/media/avatar-content.f22de387.png";